'use strict';
var baseUrl_fare = 'https://prod-opr.jugnoo.in:4013';
// var baseUrl = 'https://api-panels.jugnoo.in:7013';
// var baseUrl_fareestimate = 'https://test.jugnoo.in:7012';
var baseUrl_fareestimate = 'https://api-panels.jugnoo.in:7013';
angular.module('myApp.fireestimate', ['ngRoute']).config(['$routeProvider', function($routeProvider) {
	$routeProvider.when('/rides/fares', {
		templateUrl: '/components/rides/fareestimate.html',
		controller: 'fareEstimateCtrl',
		reloadOnSearch: false
	});
	$routeProvider.when('/rides/fares/:city', {
		templateUrl: '/components/rides/fareestimate.html',
		controller: 'fareEstimateCtrl',
		reloadOnSearch: false
	})
}]).service('fareestimate', ['$http', '$rootScope', function($http, $rootScope) {
	this.getCityData = function(params) {
		var val = $http({
			method: 'post',
			url: baseUrl_fareestimate + '/get_fare_details_city',
			data: params,
			'headers': {
				'content-type': 'application/x-www-form-urlencoded'
			},
			transformRequest: function(data) {
				return $.param(data);
			}
		});
		return val;
	};
	this.getCitiesDetails = function() {
		var val = $http({
			method: 'get',
			url: 'https://webpanels.jugnoo.in/api/smp/get_city_info',
			'headers': {
				'content-type': 'application/x-www-form-urlencoded'
			},
			transformRequest: function(data) {
				return $.param(data);
			}
		});
		return val;
	}
	this.globalReq = function(reqObj) {
		var val = $http({
			method: 'post',
			url: baseUrl_fare + '/jugnoo_web_booking',
			data: reqObj,
			'headers': {
				'content-type': 'application/x-www-form-urlencoded'
			},
			transformRequest: function(data) {
				return $.param(data);
			}
		});
		return val;
	}
}]).filter('capitalize', function() {
	return function(input) {
		return (!!input) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
	}
}).controller('fareEstimateCtrl', ['$window', '$scope', '$rootScope', '$timeout', 'MetaService', 'API',
	'fareestimate', '$location', '$routeParams',
	function($window, $scope, $rootScope, $timeout, MetaService, API, fareestimate, $location, $routeParams) {
		$rootScope.metaservice = MetaService;
		$scope.cityUrl = $routeParams.city;
		$scope.cityUrl = $scope.cityUrl.charAt(0).toUpperCase() + $scope.cityUrl.substr(1).toLowerCase();
		$rootScope.metaservice.set("Jugnoo Rides - Auto Rickshwas Online",
			"24x7 affordable and convenient auto rickshaw rides on tap from your phone.",
			"Auto, Rickshaw, Rick, Ride, Jugnoo, Online");
		//initialize variables
		$scope.getCities = getCities;
		$scope.getLocation = getLocation;
		$scope.autoCompleteFocus = autoCompleteFocus;
		$scope.reverseGeocodeSourceAddress = reverseGeocodeSourceAddress;
		// $scope.selectedCity = {};
		$scope.initMap = initMap;
		$scope.cityFare = cityFare;
		$scope.fareEstimateFn = fareEstimateFn;
		$scope.activate = activate;
		$scope.autoCompleteFocusSource = autoCompleteFocusSource;
		$scope.getFareEstimate = getFareEstimate;
		$scope.requestRide = requestRide;
		$scope.getFareDetails = getFareDetails;
		$scope.convertUTCtoIST = convertUTCtoIST;
		$scope.vehicleTypeBike = false;
		$scope.vehicleTypeAutoPool = false;
		$scope.vehicleTypeAutoNormal = false;

		function getFareDetails(setCityValue) {
			$scope.vehicleTypeAutoPool = false;
			$scope.vehicleTypeBike = false;
			$scope.vehicleTypeAutoNormal = false;
			var city_name;
			if (setCityValue) {
				city_id = setCityValue.city_id;
			}
			var params = {
				city_id: city_id
			};
			fareestimate.getCityData(params).then(function(response) {
				var result = response.data;
				$scope.citySpecificData = result.data[0].customer_fare_details;
				$scope.referral_info = result.data[0].referral_info;
				for (var i = 0; i < $scope.citySpecificData.length; i++) {
					if ($scope.citySpecificData[i].vehicle_type == 2) {
						$scope.vehicleTypeBike = true;
						break;
					}
				}
				for (var i = 0; i < $scope.citySpecificData.length; i++) {
					if ($scope.citySpecificData[i].ride_type == 2 && $scope.citySpecificData[i].vehicle_type == 1) {
						$scope.vehicleTypeAutoPool = true;
						break;
					}
				}
				for (var i = 0; i < $scope.citySpecificData.length; i++) {
					if ($scope.citySpecificData[i].ride_type == 0 && $scope.citySpecificData[i].vehicle_type == 1) {
						$scope.vehicleTypeAutoNormal = true;
						break;
					}
				}
			});
		}

		function getCities() {
			return API.get('https://api-panels.jugnoo.in:8020/get_city_info').then(function(result) {
				var data = result.data;
				$scope.cityList = data.data;
				var inputCity = $routeParams.city;
				inputCity = inputCity.charAt(0).toUpperCase() + inputCity.substr(1).toLowerCase();
				if (inputCity) {
					for (var i = 0; i < $scope.cityList.length; i++) {
						if ($scope.cityList[i].city_name === inputCity) {
							$scope.selectedCity = $scope.cityList[i];
							break;
						}
					}
				}
				getFareDetails($scope.selectedCity);
			});
		}
		getCities();
		//utc to ist 
		function convertUTCtoIST(time) {
			var hours = parseInt(time.split(':')[0]);
			var minutes = parseInt(time.split(':')[1]);
			hours += 5;
			minutes += 30;
			if (minutes >= 60) {
				hours += 1;
				minutes -= 60;
			}
			if (hours >= 24) hours -= 24;
			return hours.toLocaleString('en-US', {
				minimumIntegerDigits: 2,
				useGrouping: false
			}) + ":" + minutes.toLocaleString('en-US', {
				minimumIntegerDigits: 2,
				useGrouping: false
			}) + ":" + time.split(':')[2];
		}
		// transit map
		function initMap(end_latitude, end_longitude, sourceLat, sourceLng) {
			$scope.end_latitude = parseFloat(end_latitude)
			$scope.end_longitude = parseFloat(end_longitude)
			$scope.sourceLat = parseFloat(sourceLat)
			$scope.sourceLng = parseFloat(sourceLng)
			var directionsDisplay = new google.maps.DirectionsRenderer();
			var directionsService = new google.maps.DirectionsService();
			var map = new google.maps.Map(document.getElementById('map'), {
				zoom: 8,
				center: {
					lat: $scope.sourceLat,
					lng: $scope.sourceLng
				}
			});
			directionsDisplay.setMap(map);
			calculateAndDisplayRoute(directionsService, directionsDisplay);
			var onChangeHandler = function() {
				calculateAndDisplayRoute(directionsService, directionsDisplay);
			};
			document.getElementById('location-box').addEventListener('change', onChangeHandler);
			document.getElementById('destLocSearch').addEventListener('change', onChangeHandler);
			// document.getElementById('mode').addEventListener('change', function () {
			//     calculateAndDisplayRoute(directionsService, directionsDisplay);
			// });
		}

		function calculateAndDisplayRoute(directionsService, directionsDisplay) {
			directionsService.route({
				origin: {
					lat: $scope.sourceLat,
					lng: $scope.sourceLng
				}, // Haight.
				destination: {
					lat: $scope.end_latitude,
					lng: $scope.end_longitude
				}, // Ocean Beach.
				// Note that Javascript allows us to access the constant
				// using square brackets and a string value as its
				// "property."
				travelMode: 'DRIVING'
			}, function(response, status) {
				if (status == 'OK') {
					directionsDisplay.setDirections(response);
					// var latlng = [ new google.maps.LatLng(1.23, 4.56),
					//  new google.maps.LatLng(7.89, 1.01)]; 
					//  var latlngbounds = new google.maps.LatLngBounds();
					//  for (var i = 0; i < latlng.length; i++) {
					//      latlngbounds.extend(latlng[i]);
					//     }
					//     map.fitBounds(latlngbounds);
				} else {
					// window.alert('Directions request failed due to ' + status);
				}
			});
		}

		function requestRide() {
			$location.path("/rides");
			localStorage.removeItem('cityName');
		}

		function getFareEstimate() {
			if ($scope.endLat && $scope.startLat) {
				$scope.fareEstimateFn($scope.endLat, $scope.endLng, $scope.startLat, $scope.startLong);
			}
		}

		function getLocation() {
			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(showPosition);
			}
		}

		function showPosition(position) {
			var mapProp = {
				center: new google.maps.LatLng(position.coords.latitude, position.coords.longitude),
				zoom: 16,
			};
			$scope.startLat = position.coords.latitude;
			$scope.startLong = position.coords.longitude;
			$scope.startLat = parseFloat($scope.startLat);
			$scope.startLong = parseFloat($scope.startLong);
			var map = new google.maps.Map(document.getElementById("map"), mapProp);
			var marker = new google.maps.Marker({
				position: new google.maps.LatLng($scope.startLat, $scope.startLong),
				map: map,
			});
			reverseGeocodeSourceAddress({
				lat: position.coords.latitude,
				lng: position.coords.longitude
			});
		}

		function cityFare(value) {
			// $location.path("/rides/fares" + value.city_name);
			$scope.vehicleTypeAutoPool = false;
			$scope.vehicleTypeBike = false;
			$scope.vehicleTypeAutoNormal = false;
			var city_name;
			if (value) {
				city_id = value.city_id;
			} else {
				city_id = 1;
			}
			var params = {
				city_id: city_id
			};
			value.city_name = value.city_name.toLowerCase();
			$location.path("/rides/fares/" + value.city_name);
			//  $location.search("city", value.city_name);            
			value.city_name = value.city_name.charAt(0).toUpperCase() + value.city_name.substr(1).toLowerCase();
			// localStorage.setItem('cityName', value);
			localStorage.setItem('cityName', JSON.stringify(value));
			fareestimate.getCityData(params).then(function(response) {
				var result = response.data;
				$scope.citySpecificData = result.data[0].customer_fare_details;
				$scope.referral_info = result.data[0].referral_info;
				for (var i = 0; i < $scope.citySpecificData.length; i++) {
					if ($scope.citySpecificData[i].vehicle_type == 2) {
						$scope.vehicleTypeBike = true;
						break;
					}
				}
				for (var i = 0; i < $scope.citySpecificData.length; i++) {
					if ($scope.citySpecificData[i].ride_type == 2 && $scope.citySpecificData[i].vehicle_type == 1) {
						$scope.vehicleTypeAutoPool = true;
						break;
					}
				}
				for (var i = 0; i < $scope.citySpecificData.length; i++) {
					if ($scope.citySpecificData[i].ride_type == 0 && $scope.citySpecificData[i].vehicle_type == 1) {
						$scope.vehicleTypeAutoNormal = true;
						break;
					}
				}
			});
		}

		function fareEstimateFn(end_latitude, end_longitude, sourceLat, sourceLng) {
			fareestimate.globalReq({
				endpoint: 'fare_estimate',
				start_latitude: sourceLat,
				start_longitude: sourceLng,
				end_latitude: end_latitude,
				end_longitude: end_longitude
			}).then(function(res) {
				// $scope.fareData.fare = res.data.fare.approx_fare;
				$scope.max_fare = res.data.fare.max_fare ? res.data.fare.max_fare : 70;
				$scope.min_fare = res.data.fare.min_fare ? res.data.fare.min_fare : 80;
				$scope.ride_distance = res.data.fare.ride_distance ? res.data.fare.ride_distance : 7;
				$scope.min_ride_time = res.data.fare.min_ride_time ? res.data.fare.min_ride_time : 15;
				$scope.ride_distance_unit = res.data.fare.ride_distance_unit ? res.data.fare.ride_distance_unit :
					'km';
				$scope.ride_time_unit = res.data.fare.ride_time_unit ? res.data.fare.ride_time_unit : 15;
				$scope.approx_fare = res.data.fare.approx_fare;
				// $scope.destination = document.getElementById(
				//     'location-box').value;
				$scope.validLocation = 1;
				setTimeout(function() {
					$scope.$digest();
				});
			}, function(err) {});
			initMap(end_latitude, end_longitude, sourceLat, sourceLng);
		}
		//autocomplete map
		function autoCompleteFocus() {
			var input = document.getElementById('destLocSearch');
			var autocomplete = new google.maps.places.Autocomplete(input);
			autocomplete.addListener('place_changed', function() {
				var destignationAddress = autocomplete.getPlace();
				$scope.endLat = destignationAddress.geometry.location.lat();
				$scope.endLng = destignationAddress.geometry.location.lng();
				$scope.endLat = parseFloat($scope.endLat);
				$scope.endLng = parseFloat($scope.endLng);
				if ($scope.start_latitude) {
					// getFareEstimate();
					// $scope.fareEstimateFn($scope.endLat, $scope.endLng, $scope.startLat, $scope.startLong);
				} else {
					getLocation();
					// getFareEstimate();
					// $scope.fareEstimateFn($scope.endLat, $scope.endLng, $scope.startLat, $scope.startLong);
				}
			});
		}

		function autoCompleteFocusSource() {
			var input_source = document.getElementById('location-box');
			var autocomplete_source = new google.maps.places.Autocomplete(input_source);
			autocomplete_source.addListener('place_changed', function() {
				var place = autocomplete_source.getPlace();
				$scope.sourceLocation = place.geometry.location;
				$scope.start_latitude = place.geometry.location.lat();
				$scope.start_longitude = place.geometry.location.lng();
				$scope.start_latitude = parseFloat($scope.start_latitude);
				$scope.start_longitude = parseFloat($scope.start_longitude);
				$scope.startLat = $scope.start_latitude;
				$scope.startLong = $scope.start_longitude;
				reverseGeocodeSourceAddress({
					lat: $scope.start_latitude,
					lng: $scope.start_longitude
				});
			});
			if ($scope.endLat) {
				// getFareEstimate();
				// $scope.fareEstimateFn($scope.endLat, $scope.endLng, $scope.startLat, $scope.startLong);
			} else {
				// console.log('select destination');
			}
		}

		function reverseGeocodeSourceAddress(position) {
			var geocoder = new google.maps.Geocoder();
			geocoder.geocode({
				'location': position
			}, function(results, status) {
				if (status === 'OK') {
					$scope.sourceLocation = results[0].formatted_address;
					$scope.$digest();
					$("#loaderModal").modal('hide');
				}
			});
		}

		function activate() {
			var city_id = 1;
			cityFare(city_id);
			getLocation();
		}
	}
]);